import React from 'react'

function Textarea ({label, onChange, value, name}) {
  return (
    <div className='my-2'>
      <label className='text-back-color2 block mb-2'>{label}</label>
      <textarea
        minLength={3}
        className='w-full border p-6 border-[#343373] rounded-lg transition-all duration-300 focus:ring-2 focus:ring-[#343373]/30 focus:border-[#343373] focus:shadow-lg'
        name={name}
        required
      ></textarea>
    </div>
  )
}

export default Textarea
